/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import ErrorBoundary from 'base/components/ErrorBoundary';
import LabradorArticleTeaserDefault from 'base/components/labrador/ArticleTeaser/Default';

export const DynamicLabradorArticleTeaserDefault: typeof LabradorArticleTeaserDefault = (props) => {
    return <ErrorBoundary><LabradorArticleTeaserDefault {...props} /></ErrorBoundary>;
}
export type DynamicLabradorArticleTeaserDefaultProps = PropsFromComponent<typeof LabradorArticleTeaserDefault>;
